import { BLOCKCHAIN_NAME, EvmBlockchainName } from 'src/core/blockchain/models/blockchain-name';

export const wrappedAddress: Partial<Record<EvmBlockchainName, string>> = {
    [BLOCKCHAIN_NAME.ETHEREUM]: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
    [BLOCKCHAIN_NAME.BINANCE_SMART_CHAIN]: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
    [BLOCKCHAIN_NAME.POLYGON]: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    [BLOCKCHAIN_NAME.POLYGON_ZKEVM]: '0x4F9A0e7FD2Bf6067db6994CF12E4495Df938E6e9',
    [BLOCKCHAIN_NAME.AVALANCHE]: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',
    [BLOCKCHAIN_NAME.MOONRIVER]: '0x98878b06940ae243284ca214f92bb71a2b032b8a',
    [BLOCKCHAIN_NAME.FANTOM]: '0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83',
    [BLOCKCHAIN_NAME.HARMONY]: '0xcf664087a5bb0237a0bad6742852ec6c8d69a27a',
    [BLOCKCHAIN_NAME.ARBITRUM]: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
    [BLOCKCHAIN_NAME.AURORA]: '0xC9BdeEd33CD01541e1eeD10f90519d2C06Fe3feB',
    [BLOCKCHAIN_NAME.TELOS]: '0xd102ce6a4db07d247fcc28f366a623df0938ca9e',
    [BLOCKCHAIN_NAME.OPTIMISM]: '0x4200000000000000000000000000000000000006',
    [BLOCKCHAIN_NAME.CRONOS]: '0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23',
    [BLOCKCHAIN_NAME.OKE_X_CHAIN]: '0x8f8526dbfd6e38e3d8307702ca8469bae6c56c15',
    [BLOCKCHAIN_NAME.GNOSIS]: '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
    [BLOCKCHAIN_NAME.FUSE]: '0x0BE9e53fd7EDaC9F859882AfdDa116645287C629',
    [BLOCKCHAIN_NAME.MOONBEAM]: '0xAcc15dC74880C9944775448304B263D191c6077F',
    [BLOCKCHAIN_NAME.CELO]: '0x122013fd7df1c6f636a5bb8f03108e876548b455',
    [BLOCKCHAIN_NAME.BOBA]: '0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000',
    [BLOCKCHAIN_NAME.BOBA_BSC]: '0xC58aaD327D6D58D979882601ba8DDa0685B505eA',
    [BLOCKCHAIN_NAME.ASTAR_EVM]: '0xAeaaf0e2c81Af264101B9129C00F4440cCF0F720',
    [BLOCKCHAIN_NAME.ETHEREUM_POW]: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
    [BLOCKCHAIN_NAME.KAVA]: '0xc86c7C0eFbd6A49B35E8714C5f59D99De09A225b',
    [BLOCKCHAIN_NAME.BITGERT]: '0x0eb9036cbE0f052386f36170c6b07eF0a0E3f710',
    [BLOCKCHAIN_NAME.OASIS]: '0x21C718C22D52d0F3a789b752D4c2fD5908a8A733',
    [BLOCKCHAIN_NAME.METIS]: '0x75cb093E4D61d2A2e65D8e0BBb01DE8d89b53481',
    [BLOCKCHAIN_NAME.DFK]: '0xCCb93dABD71c8Dad03Fc4CE5559dC3D89F67a260',
    [BLOCKCHAIN_NAME.KLAYTN]: '0xe4f05a66ec68b54a58b17c22107b02e0232cc817',
    [BLOCKCHAIN_NAME.VELAS]: '0xc579D1f3CF86749E05CD06f7ADe17856c2CE3126',
    [BLOCKCHAIN_NAME.SYSCOIN]: '0xd3e822f3ef011Ca5f17D82C956D952D8d7C3A1BB',
    [BLOCKCHAIN_NAME.ZK_SYNC]: '0x5aea5775959fbc2557cc8789bc1bf90a239d9a91',
    [BLOCKCHAIN_NAME.PULSECHAIN]: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
    [BLOCKCHAIN_NAME.LINEA]: '0xe5d7c2a44ffddf6b295a15c148167daaaf5cf34f',
    [BLOCKCHAIN_NAME.BASE]: '0x4200000000000000000000000000000000000006',
    [BLOCKCHAIN_NAME.MANTLE]: '0x78c1b0C915c4FAA5FffA6CAbf0219DA63d7f4cb8',
    [BLOCKCHAIN_NAME.MANTA_PACIFIC]: '0x0Dc808adcE2099A9F62AA87D9670745AbA741746',
    [BLOCKCHAIN_NAME.SCROLL]: '0x5300000000000000000000000000000000000004',
    [BLOCKCHAIN_NAME.ZETACHAIN]: '0x5F0b1a82749cb4E2278EC87F8BF6B618dC71a8bf',
    [BLOCKCHAIN_NAME.BLAST]: '0x4300000000000000000000000000000000000004',
    [BLOCKCHAIN_NAME.KROMA]: '0x4200000000000000000000000000000000000001',
    [BLOCKCHAIN_NAME.HORIZEN_EON]: '0xF5cB8652a84329A2016A386206761f455bCEDab6',
    [BLOCKCHAIN_NAME.MERLIN]: '0xF6D226f9Dc15d9bB51182815b320D3fBE324e1bA',
    [BLOCKCHAIN_NAME.ROOTSTOCK]: '0x542fda317318ebf1d3deaf76e0b632741a7e677d',
    [BLOCKCHAIN_NAME.MODE]: '0x4200000000000000000000000000000000000006',
    [BLOCKCHAIN_NAME.ZK_FAIR]: '0xD33Db7EC50A98164cC865dfaa64666906d79319C',
    [BLOCKCHAIN_NAME.ZK_LINK]: '0x8280a4e7d5b3b658ec4580d3bc30f5e50454f169',
    [BLOCKCHAIN_NAME.XLAYER]: '0xe538905cf8410324e03A5A23C1c177a474D59b2b',
    [BLOCKCHAIN_NAME.TAIKO]: '0xa51894664a773981c6c112c43ce576f315d5b1b6',
    [BLOCKCHAIN_NAME.SEI]: '0xE30feDd158A2e3b13e9badaeABaFc5516e95e8C7',
    [BLOCKCHAIN_NAME.CORE]: '0x191e94fa59739e188dce837f7f6978d84727ad01',
    [BLOCKCHAIN_NAME.BAHAMUT]: '0x4084ab20f8ffca76c19aaf854fb5fe9de6217fbb',
    [BLOCKCHAIN_NAME.GRAVITY]: '0xBB859E225ac8Fb6BE1C7e38D87b767e95Fef0EbD',
    [BLOCKCHAIN_NAME.FLARE]: '0x1d80c49bbbcd1c0911346656b529df9e5c2f783d',
    [BLOCKCHAIN_NAME.SONIC]: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
    [BLOCKCHAIN_NAME.MORPH]: '0x5300000000000000000000000000000000000011',
    [BLOCKCHAIN_NAME.FRAXTAL]: '0xfc00000000000000000000000000000000000006',
    [BLOCKCHAIN_NAME.BERACHAIN]: '0x6969696969696969696969696969696969696969',
    [BLOCKCHAIN_NAME.SONEIUM]: '0x4200000000000000000000000000000000000006',
    [BLOCKCHAIN_NAME.UNICHAIN]: '0x4200000000000000000000000000000000000006',
    // Testnet
    [BLOCKCHAIN_NAME.GOERLI]: '0xb4fbf271143f4fbf7b91a5ded31805e42b2208d6',
    [BLOCKCHAIN_NAME.SCROLL_SEPOLIA]: '0x5300000000000000000000000000000000000004',
    [BLOCKCHAIN_NAME.ARTHERA]: '0xC7A183Ad373301d68f7E0Ee824c8c727C7D5B21d',
    [BLOCKCHAIN_NAME.SEPOLIA]: '0xfff9976782d46cc05630d1f6ebab18b2324d6b14',
    [BLOCKCHAIN_NAME.BERACHAIN_TESTNET]: '0x7507c1dc16935B82698e4C63f2746A2fCf994dF8',
    [BLOCKCHAIN_NAME.BLAST_TESTNET]: '0x4200000000000000000000000000000000000023',
    [BLOCKCHAIN_NAME.HOLESKY]: '',
    [BLOCKCHAIN_NAME.BITLAYER]: '0xff204e2681a6fa0e2c3fade68a1b28fb90e4fc5f',
    [BLOCKCHAIN_NAME.UNICHAIN_SEPOLIA_TESTNET]: '0x4200000000000000000000000000000000000006',
    [BLOCKCHAIN_NAME.SONEIUM_TESTNET]: '0x4200000000000000000000000000000000000006',
    [BLOCKCHAIN_NAME.MONAD_TESTNET]: '0x760AfE86e5de5fa0Ee542fc7B7B713e1c5425701',
    [BLOCKCHAIN_NAME.MEGAETH_TESTNET]: '0x4eB2Bd7beE16F38B1F4a0A5796Fffd028b6040e9'
};
